function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}

function _asyncToGenerator(fn) {
    return function () {
        var self = this, args = arguments;
        return new Promise(function (resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}

(function () {
    "use strict";
    var regions = [
        { code: "GB", name: "United Kingdom", currency: "GBP", url: "https://tateossian.com" },
        { code: "US", name: "United States", currency: "USD", url: "https://us.tateossian.com" },
        { code: "EU", name: "Europe", currency: "EUR", url: "https://eu.tateossian.com" }
    ];

    var euCountries = [
        "BE", "BG", "CZ", "DK", "DE", "EE", "IE", "EL", "ES", "FR", "HR", "IT", "CY", "LV", "LT", "LU", "HU", "MT", "NL", "AT", "PL", "PT", "RO", "SI", "SK", "FI", "SE"
    ];

    class LocaleSwitcher extends HTMLElement {
        constructor() {
            super();
            this.popUpLocationText = this.querySelector(".localization-popup__current-region");
            this.localizationPopUp = this.querySelector(".localization-popup");
            this.localizationPopUpModal = this.querySelector(".localization-popup__modal");
            this.selectedRegion = this.querySelector(".selected-option");
            this.localizationPopUpButton = this.querySelector(".localization-redirect__button");
            this.detectedRegionImage = this.querySelector(".current-region__image");
            this.exitButton = this.querySelector(".exit-button");
            this.setUpEventListeners();
            this.displayPopupIfNeeded();
            this.setSelectedRegion();
            this.currentLocale = window.currentLocale;
        }

        setSelectedRegion() {
            var customSelect = document.querySelector(".custom-select");
            var selectedOption = customSelect.querySelector(".selected-option");
            var options = customSelect.querySelector(".options");

            if (selectedOption) {
                selectedOption.addEventListener("click", () => {
                    options.style.display = options.style.display === "block" ? "none" : "block";
                });
            }

            if (options) {
                options.querySelectorAll(".option").forEach(option => {
                    option.addEventListener("click", () => {
                        // Helper function to safely access nested properties
                        function safeAccess(arr) {
                            var context, value = arr[0], i = 1;
                            while (i < arr.length) {
                                var op = arr[i], fn = arr[i + 1];
                                i += 2;
                                if ((op === "optionalAccess" || op === "optionalCall") && value == null) return;
                                if (op === "access" || op === "optionalAccess") {
                                    context = value;
                                    value = fn(value);
                                } else if (op === "call" || op === "optionalCall") {
                                    value = fn(function () {
                                        var args = Array.prototype.slice.call(arguments);
                                        return value.call(context, ...args);
                                    });
                                    context = undefined;
                                }
                            }
                            return value;
                        }

                        var regionCode = safeAccess([
                            option, "access", o => o.dataset,
                            "access", d => d.region,
                            "optionalAccess", r => r.toLowerCase,
                            "call", r => r()
                        ]);

                        selectedOption.innerHTML =
                            `<img
                                src="//cdn.shopify.com/static/images/flags/${regionCode}.svg?width=32"
                                alt="EU"
                                srcset="//cdn.shopify.com/static/images/flags/${regionCode}.svg?width=32 32w"
                                width="32"
                                height="24"
                            >  ${option.innerText}`;
                        selectedOption.dataset.region = option.dataset.region;
                        options.style.display = "none";
                    });
                });
            }
        }

        setUpEventListeners() {
            if (this.localizationPopUpButton) {
                this.localizationPopUpButton.addEventListener("click", () => {
                    document.cookie = "locale_redirect=true; domain=.tateossian.com; path=/";
                    regions.forEach(region => {
                        if (region.code === this.selectedRegion.dataset.region) {
                            window.location.href = region.url;
                        }
                    });
                });
            }

            if (this.exitButton) {
                this.exitButton.addEventListener("click", () => {
                    document.cookie = "locale_redirect=true; domain=.tateossian.com; path=/";
                    this.localizationPopUp.style.display = "none";
                });
            }

            if (this.localizationPopUp) {
                this.localizationPopUp.addEventListener("click", () => {
                    document.cookie = "locale_redirect=true; domain=.tateossian.com; path=/";
                    this.localizationPopUp.style.display = "none";
                });
            }

            if (this.localizationPopUpModal) {
                this.localizationPopUpModal.addEventListener("click", e => {
                    e.stopPropagation();
                });
            }
        }

        detectIfPopUpNeeded(regionCode) {
            return !(
                (regionCode === "GB" && window.location.hostname === "tateossian.com") ||
                (euCountries.includes(regionCode) && window.location.hostname === "eu.tateossian.com") ||
                (regionCode === "US" && window.location.hostname === "us.tateossian.com")
            );
        }

        displayPopupIfNeeded() {
            var self = this;
            return _asyncToGenerator(function* () {
                var detectedRegion = yield self.detectLocale();
                var localeRedirectCookie = (function (name) {
                    var parts = "; " + document.cookie.split("; " + name + "=");
                    if (parts.length === 2) return parts.pop().split(";").shift();
                })("locale_redirect");

                if (!self.detectIfOnLocalStore(detectedRegion) && !localeRedirectCookie) {
                    var regionCodeLower = detectedRegion.toLowerCase();
                    if (detectedRegion === "GB") {
                        self.selectedRegion.dataset.region = "GB";
                        self.selectedRegion.innerHTML =
                            `<img
                                src="//cdn.shopify.com/static/images/flags/gb.svg?width=32"
                                alt="United Kingdom"
                                srcset="//cdn.shopify.com/static/images/flags/gb.svg?width=32 32w"
                                width="32"
                                height="24"
                            >  United Kingdom`;
                    } else if (euCountries.includes(detectedRegion)) {
                        self.selectedRegion.dataset.region = "EU";
                        self.selectedRegion.innerHTML =
                            `<img
                                src="//cdn.shopify.com/static/images/flags/eu.svg?width=32"
                                alt="EU"
                                srcset="//cdn.shopify.com/static/images/flags/eu.svg?width=32 32w"
                                width="32"
                                height="24"
                            >  EU`;
                    } else {
                        self.selectedRegion.dataset.region = "US";
                        self.selectedRegion.innerHTML =
                            `<img
                                src="//cdn.shopify.com/static/images/flags/us.svg?width=32"
                                alt="United States"
                                srcset="//cdn.shopify.com/static/images/flags/us.svg?width=32 32w"
                                width="32"
                                height="24"
                            >  United States`;
                    }

                    if (self.localizationPopUp) {
                        self.localizationPopUp.style.display = "flex";
                        self.detectedRegionImage.setAttribute("src", `//cdn.shopify.com/static/images/flags/${regionCodeLower}.svg?width=32`);
                        self.detectedRegionImage.setAttribute("srcset", `//cdn.shopify.com/static/images/flags/${regionCodeLower}.svg?width=32`);
                    }

                    regions.forEach(region => {
                        if (detectedRegion === region.code) {
                            self.popUpLocationText.innerHTML = region.name;
                        }
                    });
                }
            })();
        }

        detectIfOnLocalStore(regionCode) {
            var isLocal = false;
            if (
                (window.location.hostname === "tateossian.com" && regionCode === "GB") ||
                (window.location.hostname === "us.tateossian.com" && regionCode === "US") ||
                (window.location.hostname === "eu.tateossian.com" && euCountries.includes(regionCode))
            ) {
                isLocal = true;
            }
            return isLocal;
        }

        detectLocale() {
            var self = this;
            return _asyncToGenerator(function* () {
                var response = yield fetch(`${window.Shopify.routes.root}browsing_context_suggestions.json`).then(res => res.json());
                var hostname = window.location.hostname;
                if (response.detected_values && response.detected_values.country && response.detected_values.country.handle) {
                    if (self.popUpLocationText) {
                        self.popUpLocationText.innerHTML = response.detected_values.country.name;
                    }
                    return response.detected_values.country.handle;
                }
                return "GB";
            })();
        }
    }

    if (!customElements.get("locale-switcher")) {
        customElements.define("locale-switcher", LocaleSwitcher);
    }
})();
